/**
 * Based on ckEditor/src/ckeditor5-footnote/theme/ckeditor5-footnote-icon.svg
 */
import React from 'react';

export const CkFootnoteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2200 1800"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M 400 100 L 100 100 M 100 100 L 100 1700 M 100 1700 L 400 1700"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeWidth="160"
    />
    <path
      d="M 1800 100 L 2100 100 M 2100 1700 L 1800 1700 M 2100 100 L 2100 1700"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeWidth="160"
    />
    <path
      d="M 1100 438.12 L 1100 1361.88 M 1500 669.06 L 700 1130.94 M 1499.999 1130.938 L 700.001 669.059"
      strokeLinecap="round"
      strokeWidth="160"
    />
  </svg>
);
